import * as React from 'react';
import { withT, TFunction } from '@spotify-internal/i18n-core';

type ErrorBoundaryProps = {
  fallback: React.ReactNode | ((error: Error, t: TFunction) => React.ReactNode);
  children: React.ReactNode;
  onError: (error: Error, errorInfo: React.ErrorInfo) => void;
  resetKey?: string;
  t: TFunction;
};

type ErrorBoundaryState = { error: Error | null };

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  componentDidUpdate(prevProps: ErrorBoundaryProps) {
    if (prevProps.resetKey !== this.props.resetKey) {
      // eslint-disable-next-line
      this.setState({ error: null });
    }
  }

  render() {
    const { fallback, children, t } = this.props;
    const { error } = this.state;

    if (error) {
      if (typeof fallback === 'function') {
        return fallback(error, t);
      }

      return fallback;
    }

    return children;
  }
}

export default withT(ErrorBoundary);
